export type AwardRuleIconKey = 'post' | 'comment' | 'like' | 'share' | 'delete';

const AWARD_RULE_ICON_KEYS: Record<string, AwardRuleIconKey> = {
  post: 'post',
  login: 'post',
  comment: 'comment',
  postliked: 'like',
  commentlike: 'like',
  postshare: 'share',
  postdelete: 'delete',
};

export const awardRuleIconKey = (
  ruleFor?: string | null,
): AwardRuleIconKey =>
  AWARD_RULE_ICON_KEYS[String(ruleFor ?? '').toLowerCase()] ?? 'post';
